<template>
    <div class="page-select page">
        <div class="bg">
            <div class="lantern">
                <img src="../assets/img/bg_lantern.png" alt="">
            </div>
        </div>
        <div class="page-inner">
            <div class="main">
                <div class="main-inner">
                    <div class="page-info">
                        <div class="page-info-inner">
                            <p>选最喜欢的食材，</p>
                            <p>做最爱的汤圆咯！</p>
                            <div class="dialog-xf">
                                <img src="../assets/img/dialog_icon.png" alt="">
                            </div>
                            <div class="dialog-star">
                                <img src="../assets/img/planet.png" alt="">
                            </div>
                        </div>
                    </div>
                    <div class="select-item" v-for="(item, index) in list">
                        <h4 class="title">
                            <img :src="item.title" alt="">
                        </h4>
                        <ul>
                            <li v-for="(clItem, clIndex) in item.list" :class="[selects[index] && selects[index].indexOf(clIndex) > -1 && 'selected']" @click="select(index, clIndex)">
                                <div class="img">
                                    <img :src="clItem.img" alt="">
                                </div>
                                <p v-html="clItem.name"></p>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="select-btn" :class="[!allSelected && 'grey']" @click="makeTy">
                    <img src="../assets/img/do_btn.png" alt="">
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import { mapState, mapMutations } from 'vuex'


@Options({
    data () {
        return {
            list: [],
            selects: [],
            allSelected: false,
            blessings: ['团团圆圆，平安喜乐！', '今夜的月亮，散着团圆的光！', '闹元宵，汤圆吃出幸福新一年！', '月圆心甜，幸幸福福新一年！', '元宵月，愿与你共赏团圆！', '甜蜜汤圆，是节日最好的礼物！', '闹花灯，吃汤圆，和和美美又一年！', '点一盏元宵灯；吃一碗甜汤圆！'],
            isGeting: false
        }
    },
    computed: {
        ...mapState(['aid', 'userInfo', 'shareData', 'activityData'])
    },
    created () {
        this.getList(this.$route.query.type)
    },
    mounted () {
        this.activityData && this.$common.pageLoaded()
        this.shareData.title && this.$common.onshare(this.shareData)
        this.$common.track('load', '进入做汤圆页面')
    },
    methods: {
        ...mapMutations(['SET_USERINFO', 'SET_HBDATA', 'SET_DIALOGDATA']),
        getList (type: string) {
            this.list  = [
                {
                    title: require('@/assets/img/select_title_01.png'),
                    list: [
                        {
                            name: '甜蜜<br>汤圆粉',
                            img: require('@/assets/img/make_zc_01.png')
                        },
                        {
                            name: '幸福<br>汤圆粉',
                            img: require('@/assets/img/make_zc_02.png')
                        },
                        {
                            name: '喜乐<br>汤圆粉',
                            img: require('@/assets/img/make_zc_03.png')
                        },
                        {
                            name: '开心<br>汤圆粉',
                            img: require('@/assets/img/make_zc_04.png')
                        },
                        {
                            name: '团圆<br>汤圆粉',
                            img: require('@/assets/img/make_zc_05.png')
                        }
                    ]
                },
                {
                    title: require('@/assets/img/select_title_03.png'),
                    list: [
                        {
                            name: type === 'salt' ? '鸡肉' : '花生',
                            img: require(`@/assets/img/${type}_pl_01.png`)
                        },
                        {
                            name: type === 'salt' ? '菜肉' : '芝麻',
                            img: require(`@/assets/img/${type}_pl_02.png`)
                        },
                        {
                            name: type === 'salt' ? '虾球' : '果酱',
                            img: require(`@/assets/img/${type}_pl_03.png`)
                        },
                        {
                            name: type === 'salt' ? '猪肉' : '朱古力',
                            img: require(`@/assets/img/${type}_pl_04.png`)
                        },
                        {
                            name: type === 'salt' ? '芥菜' : '核桃仁',
                            img: require(`@/assets/img/${type}_pl_05.png`)
                        }
                    ]
                },
                {
                    title: require('@/assets/img/select_title_02.png'),
                    list: [
                        {
                            name: type === 'salt' ? '盐' : '白砂糖',
                            img: require(`@/assets/img/${type}_fl_01.png`)
                        },
                        {
                            name: type === 'salt' ? '小葱' : '细砂糖',
                            img: require(`@/assets/img/${type}_fl_02.png`)
                        },
                        {
                            name: type === 'salt' ? '鸡精' : '红糖',
                            img: require(`@/assets/img/${type}_fl_03.png`)
                        },
                        {
                            name: type === 'salt' ? '胡椒粉' : '黄砂糖',
                            img: require(`@/assets/img/${type}_fl_04.png`)
                        },
                        {
                            name: '油',
                            img: require(`@/assets/img/${type}_fl_05.png`)
                        }
                    ]
                }
            ]
        },
        select (index: number, clIndex: number) {
            let newVal = JSON.parse(JSON.stringify(this.selects))[index]
            if (newVal && newVal.indexOf(clIndex) > -1) {
                newVal.splice(newVal.indexOf(clIndex), 1)
                this.selects[index] = newVal
            } else {
                this.selects[index] = newVal ? newVal.concat([clIndex]) : [clIndex]
            }
            this.allSelected = this.selects.filter((val: number[]) => {
                return val !== undefined && val !== null && val.length > 0
            }).length == 3
        },
        makeTy () {
            if (!this.allSelected) {
                this.$common.toast('请选择汤圆的主料、配料、辅料再“制作汤圆”。')
                return
            }
            this.$common.track('click', '制作汤圆')
            this.getHb()
        },
        getHb () {
            if (this.isGeting) return
            this.isGeting = true
            this.SET_DIALOGDATA({
                text: '甜蜜汤圆制作中，请稍等...'
            })
            this.$request('/lottery/luck', {
                aid: this.aid,
                userinfo: this.userInfo
            }, 'post').then((data: any) => {
                data.amount = (data.amount / 100).toFixed(2)
                this.SET_HBDATA(data)
                this.$router.push({
                    path: '/complete'
                })
                this.SET_DIALOGDATA(null)
                this.isGeting = false
            }).catch((res: any) => {
                if (res && res.errno == 1010) {
                    this.$common.toast('亲，请完成安全验证')
                } else {
                    this.SET_HBDATA({
                        blessing: this.blessings[Math.floor(Math.random() * this.blessings.length)]
                    })
                    this.$router.push({
                        path: '/complete'
                    })
                }
                this.SET_DIALOGDATA(null)
                this.isGeting = false
            })
        },
    }
})
export default class Select extends Vue {}
</script>

<style lang="scss">
.page-select {
    position: relative;
    min-height: 100%;
    .page-inner {
        position: relative;
        text-align: center;
        line-height: 0;
        height: 100%;
        z-index: 1;
    }
    .main {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        box-sizing: border-box;
        padding: .740741rem 0 .611111rem;
        z-index: 2;
        display: flex;
        align-items: center;
        .main-inner {
            display: flex;
            flex-wrap: wrap;
            position: relative;
            width: 100%;
        }
        .page-info {
            height: 2.416667rem;
            position: relative;
            left: 59%;
            right: auto;
            bottom: 0;
            margin-bottom: .944444rem;
            &::before {
                bottom: -12px;
            }
            &::after {
                left: 30.5px;
                bottom: -10px;
            }
            .page-info-inner {
                padding: .462963rem 0 0;
                p {
                    font-size: .416667rem;
                    text-align: left;
                    text-indent: .527778rem;
                    line-height: 1.4;
                }
                .dialog-xf {
                    width: 1.092593rem;
                    top: .231481rem;
                    left: -0.759259rem;
                }
            }
        }
        .select-item {
            margin-bottom: .518519rem;
            width: 100%;
            padding: 0 .722222rem;
            box-sizing: border-box;
            .title {
                width: 2.166667rem;
                height: .916667rem;
                margin: 0 auto .055556rem;
            }
            ul {
                list-style: none;
                display: flex;
                justify-content: space-between;
                align-items: flex-end;
                border-bottom: 2px dotted #a54d6f;
                padding-bottom: .277778rem;
                li {
                    width: 1.194444rem;
                    .img {
                        height: 1.157407rem;
                        margin-bottom: .138889rem;
                        display: flex;
                        align-items: flex-end;
                    }
                    p {
                        font-family: 'GEhye4gj';
                        font-weight: bold;
                        line-height: 1.3;
                        font-size: .277778rem;
                        color: #25467a;
                        white-space: nowrap;
                    }
                    &.selected {
                        p {
                            color: #fff;
                        }
                    }
                }
            }
            &:nth-of-type(3), &:nth-of-type(4) {
                ul {
                    li {
                        width: 1.407407rem;
                    }
                }
            }
            &:nth-of-type(4) {
                ul {
                    border-bottom: none;
                    padding-bottom: 0;
                }
            }
        }
        .select-btn {
            position: absolute;
            width: 2.564815rem;
            left: 50%;
            transform: translateX(-50%);
            bottom: -.685185rem;
            &.grey {
                filter: grayscale(1);
            }
        }
    }
    .bg {
        .lantern {
            right: auto;
            left: .574074rem;
        }
    }
}

@keyframes upDown {
    0% {
        opacity: 0;
        transform: translateY(0);
    }
    100% {
        opacity: 1;
        transform: translateY(-5%);
    }
}

</style>
